// extracted by mini-css-extract-plugin
export default {"loadingImage":"loading_loadingImage__i3iBs","loading":"loading_loading__A2A6-"};